import {keyMirror} from 'utils/DBUtils';

export const Types = keyMirror({
  SET_FILTER_RESOURCE: null,
  SET_INITIAL_COLUMNS: null,
  SET_VISIBLE_COLUMNS_MODAL: null,
  UPDATE_VISIBLE_COLUMNS: null,
  SAVE_VISIBLE_COLUMNS: null,

  REGISTER_FIELDS: null,
  SET_QUERY: null,
  CLEAR_QUERY: null,
  UPDATE_QUERY: null,
  UPDATE_USER_SELECTION: null,

  REQUEST_USER_DETAILS: null,

  RECEIVED_USER_RESOURCE: null,
  FAILED_USER_RESOURCE: null,

  RECEIVED_STARTS_COMPLETES: null,
  FAILED_STARTS_COMPLETES: null,

  RECEIVED_RAFFLE_ENTRIES: null,
  FAILED_RAFFLE_ENTRIES: null,

  RECEIVED_PRIZEBOOTH_ORDERS: null,
  FAILED_PRIZEBOOTH_ORDERS: null,

  RECEIVED_POINT_HISTORY: null,
  FAILED_POINT_HISTORY: null,

  USER_FETCHES_COMPLETE: null,

  START_CREATE_USER: null,
  SUBMIT_CREATE_USER: null,
  CREATE_USER_SUCCESS: null,
  END_CREATE_USER: null,

  START_AWARD_POINTS: null,
  SUBMIT_AWARD_POINTS: null,
  END_AWARD_POINTS: null,
  ERROR_AWARDING_POINTS: null,

  START_AWARD_SPINS: null,
  SUBMIT_AWARD_SPINS: null,
  END_AWARD_SPINS: null,

  START_AWARD_DAYS: null,
  SUBMIT_AWARD_DAYS: null,
  END_AWARD_DAYS: null,

  START_CHANGE_EMAIL: null,
  SUBMIT_CHANGE_EMAIL: null,
  END_CHANGE_EMAIL: null,

  START_CHANGE_PASSWORD: null,
  SUBMIT_CHANGE_PASSWORD: null,
  END_CHANGE_PASSWORD: null,

  START_REPAIR_PROFILE: null,
  SUBMIT_REPAIR_PROFILE: null,
  END_REPAIR_PROFILE: null,

  SUBMIT_DELETE_USER: null,
  SUBMIT_UNDELETE_USER: null,

  START_REVOKE_AMOUNT_OF_POINTS: null,
  SUBMIT_REVOKE_AMOUNT_OF_POINTS: null,
  END_REVOKE_AMOUNT_OF_POINTS: null,

  START_REVOKE_POINTS: null,
  SUBMIT_REVOKE_POINTS: null,
  END_REVOKE_POINTS: null,

  START_DELETE_USER_DATA: null,
  SUBMIT_DELETE_USER_DATA: null,
  END_DELETE_USER_DATA: null
});




export const setFilterResourceAction = filterResource => ({
  type: Types.SET_FILTER_RESOURCE,
  filterResource
});

export const setInitialColumnsAction = columns => ({
  type: Types.SET_INITIAL_COLUMNS,
  columns
});

export const setVisibleColumnsModalAction = isOpen => ({
  type: Types.SET_VISIBLE_COLUMNS_MODAL,
  isOpen
});

export const updateVisibleColumnsAction = (sectionName, visibleColumns) => ({
  type: Types.UPDATE_VISIBLE_COLUMNS,
  sectionName,
  visibleColumns
});

export const saveVisibleColumnsAction = () => ({
  type: Types.SAVE_VISIBLE_COLUMNS
});


export const startCreateUserAction = () => ({
  type: Types.START_CREATE_USER
});

export const submitCreateUserAction = formData => ({
  type: Types.SUBMIT_CREATE_USER,
  formData
});

export const createUserSuccessAction = uid => ({
  type: Types.CREATE_USER_SUCCESS,
  uid
});

export const endCreateUserAction = () => ({
  type: Types.END_CREATE_USER
});


export const registerFieldsAction = formFields => ({
  type: Types.REGISTER_FIELDS,
  formFields
});

export const setQueryAction = query => ({
  type: Types.SET_QUERY,
  query
});

export const clearQueryAction = () => ({
  type: Types.CLEAR_QUERY
});

export const updateQueryAction = (field, value) => ({
  type: Types.UPDATE_QUERY,
  field,
  value
});

export const updateUserSelectionAction = (id, selected) => ({
  type: Types.UPDATE_USER_SELECTION,
  id,
  selected
});

export const fetchUserAction = userId => ({
  type: Types.REQUEST_USER_DETAILS,
  userId
});

export const receivedUserResourceAction = user => ({
  type: Types.RECEIVED_USER_RESOURCE,
  user
});

export const failedUserResourceAction = ajaxError => ({
  type: Types.FAILED_USER_RESOURCE,
  ajaxError
});

export const receivedStartsCompletesAction = startsCompletes => ({
  type: Types.RECEIVED_STARTS_COMPLETES,
  startsCompletes
});

export const failedStartsCompletesAction = ajaxError => ({
  type: Types.FAILED_STARTS_COMPLETES,
  ajaxError
});

export const receivedRaffleEntriesAction = raffleEntries => ({
  type: Types.RECEIVED_RAFFLE_ENTRIES,
  raffleEntries
});

export const failedRaffleEntriesAction = ajaxError => ({
  type: Types.FAILED_RAFFLE_ENTRIES,
  ajaxError
});

export const receivedPrizeboothOrdersAction = prizeboothOrders => ({
  type: Types.RECEIVED_PRIZEBOOTH_ORDERS,
  prizeboothOrders
});

export const failedPrizeboothOrdersAction = ajaxError => ({
  type: Types.FAILED_PRIZEBOOTH_ORDERS,
  ajaxError
});

export const receivedPointHistoryAction = pointHistory => ({
  type: Types.RECEIVED_POINT_HISTORY,
  pointHistory
});

export const failedPointHistoryAction = ajaxError => ({
  type: Types.FAILED_POINT_HISTORY,
  ajaxError
});

export const userFetchesCompleteAction = () => ({
  type: Types.USER_FETCHES_COMPLETE
});



export const startAwardPointsAction = () => ({
  type: Types.START_AWARD_POINTS
});

export const submitAwardPointsAction = (uid, amount, reason) => ({
  type: Types.SUBMIT_AWARD_POINTS,
  uid,
  amount,
  reason
});

export const endAwardPointsAction = () => ({
  type: Types.END_AWARD_POINTS
});

export const errorAwardingPointsAction = (message) => ({
    type: Types.ERROR_AWARDING_POINTS,
    message
});


export const startAwardSpinsAction = () => ({
  type: Types.START_AWARD_SPINS
});

export const submitAwardSpinsAction = (uid, amount) => ({
  type: Types.SUBMIT_AWARD_SPINS,
  uid,
  amount
});

export const endAwardSpinsAction = () => ({
  type: Types.END_AWARD_SPINS
});



export const startAwardDaysAction = () => ({
  type: Types.START_AWARD_DAYS
});

export const submitAwardDaysAction = (uid, amount) => ({
  type: Types.SUBMIT_AWARD_DAYS,
  uid,
  amount
});

export const endAwardDaysAction = () => ({
  type: Types.END_AWARD_DAYS
});


export const startChangeEmailAction = () => ({
  type: Types.START_CHANGE_EMAIL
});

export const submitChangeEmailAction = (uid, newEmail) => ({
  type: Types.SUBMIT_CHANGE_EMAIL,
  uid,
  newEmail
});

export const endChangeEmailAction = () => ({
  type: Types.END_CHANGE_EMAIL
});


export const startChangePasswordAction = () => ({
  type: Types.START_CHANGE_PASSWORD
});

export const submitChangePasswordAction = (uid, newPassword, newPasswordConfirm) => ({
  type: Types.SUBMIT_CHANGE_PASSWORD,
  uid,
  newPassword,
  newPasswordConfirm
});

export const endChangePasswordAction = () => ({
  type: Types.END_CHANGE_PASSWORD
});



export const startRepairProfileAction = () => ({
  type: Types.START_REPAIR_PROFILE
});

export const submitRepairProfileAction = () => ({
  type: Types.SUBMIT_REPAIR_PROFILE,
});

export const endRepairProfileAction = () => ({
  type: Types.END_REPAIR_PROFILE
});



export const submitDeleteUserAction = () => ({
  type: Types.SUBMIT_DELETE_USER
});

export const submitUndeleteUserAction = () => ({
  type: Types.SUBMIT_UNDELETE_USER
});


export const startRevokeAmountOfPointsAction = () => ({
  type: Types.START_REVOKE_AMOUNT_OF_POINTS
});

export const submitRevokeAmountOfPointsAction = (uid, amount, reason) => ({
  type: Types.SUBMIT_REVOKE_AMOUNT_OF_POINTS,
  uid,
  amount,
  reason
});

export const endRevokeAmountOfPointsAction = () => ({
  type: Types.END_REVOKE_AMOUNT_OF_POINTS
});

export const startRevokePointsAction = phid => ({
  type: Types.START_REVOKE_POINTS,
  phid
});

export const submitRevokePointsAction = () => ({
  type: Types.SUBMIT_REVOKE_POINTS
});

export const endRevokePointsAction = () => ({
  type: Types.END_REVOKE_POINTS
});

export const startDeleteUserDataAction = (user) => ({
  type: Types.START_DELETE_USER_DATA,
  user: user
});

export const submitDeleteUserDataAction = () => ({
  type: Types.SUBMIT_DELETE_USER_DATA
});

export const endDeleteUserDataAction = () => ({
  type: Types.END_DELETE_USER_DATA
});



// WEBPACK FOOTER //
// ./public/pages/UserManagement/actions.js